import { Controller } from "@hotwired/stimulus"

// The breaker panel drawing: click a breaker (or its label) to see what it powers.
export default class extends Controller {
  static targets = ["switch", "label", "detail"]

  declare readonly switchTargets: HTMLElement[]
  declare readonly labelTargets: HTMLElement[]
  declare readonly detailTargets: HTMLElement[]

  select(event: Event) {
    const ids = ((event.currentTarget as HTMLElement).dataset.circuit || "").split(" ").filter(Boolean)
    const id = ids[0]
    if (!id) return

    ;[...this.switchTargets, ...this.labelTargets].forEach((el) => {
      const own = (el.dataset.circuit || "").split(" ")
      el.classList.toggle("is-selected", own.includes(id))
    })
    this.detailTargets.forEach((detail) => (detail.hidden = detail.dataset.detail !== id))
  }
}
